import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import {
  IExcelAnnouncement,
  IExcelAnnouncementFileAddRequest,
  IExcelAnnouncementImportReport,
  IExcelAnnouncementListRequest,
  IExcelAnnouncementRow,
  IExcelAnnouncementRowFilter,
  IExcelAnnouncementRowGroup,
  IExcelAnnouncementSaveRequest,
} from '../models/excelAnnouncementModels'

/**
 * Excel ile bayi bazlı duyuru uçları (admin/excelAnnouncement).
 * Excel dosyası korumalı alanda tutuluyor; indirme adresi sunucuda imzalanıp
 * DownloadUrl alanıyla geliyor.
 */
export class ExcelAnnouncementService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async save(request: IExcelAnnouncementSaveRequest): Promise<IExcelAnnouncementImportReport> {
    this.props.url = 'admin/excelAnnouncement/post'
    return await this.postAsync<IExcelAnnouncementImportReport>(request)
  }

  public async update(request: IExcelAnnouncementSaveRequest): Promise<IExcelAnnouncement> {
    this.props.url = 'admin/excelAnnouncement/update'
    return await this.putAsync<IExcelAnnouncement>(undefined, request)
  }

  public async addFile(request: IExcelAnnouncementFileAddRequest): Promise<IExcelAnnouncementImportReport> {
    this.props.url = 'admin/excelAnnouncement/addFile'
    return await this.postAsync<IExcelAnnouncementImportReport>(request)
  }

  public async getFiltered(request: IExcelAnnouncementListRequest): Promise<IExcelAnnouncement[]> {
    this.props.url = 'admin/excelAnnouncement/GetFiltered'
    return await this.postAsync<IExcelAnnouncement[]>(request)
  }

  public async getById(id: number): Promise<IExcelAnnouncement> {
    this.props.url = `admin/excelAnnouncement/getById/${id}`
    return await this.getAsync<IExcelAnnouncement>()
  }

  public async getRowSummary(filter: IExcelAnnouncementRowFilter): Promise<IExcelAnnouncementRowGroup[]> {
    this.props.url = 'admin/excelAnnouncement/rowSummary'
    return await this.postAsync<IExcelAnnouncementRowGroup[]>(filter)
  }

  public async getRows(filter: IExcelAnnouncementRowFilter): Promise<IExcelAnnouncementRow[]> {
    this.props.url = 'admin/excelAnnouncement/rows'
    return await this.postAsync<IExcelAnnouncementRow[]>(filter)
  }

  public async deleteFile(fileId: number): Promise<IExcelAnnouncement> {
    this.props.url = `admin/excelAnnouncement/file/${fileId}`
    return await this.deleteAsync<IExcelAnnouncement>()
  }

  public async remove(id: number): Promise<boolean> {
    this.props.url = `admin/excelAnnouncement/${id}`
    return await this.deleteAsync<boolean>()
  }
}
